'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/**
 *
 * @param {String|Number} numbers
 * @return {Number}
 */
var digit = function digit(numbers) {
  var index = 2;
  var reverse = numbers.split('').reduce(function (buffer, number) {
    return [+number].concat(buffer);
  }, []);
  var sum = reverse.reduce(function (buffer, number) {
    buffer += number * index;
    index = index === 9 ? 2 : index + 1;
    return buffer;
  }, 0);
  var mod = sum % 11;
  return mod < 2 ? 0 : 11 - mod;
};
/**
 * Remove non digit characters from CNPJ
 * @param {String|Number} value The CNPJ value to be cleaned
 */
var clean = function clean() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return value.toString().replace(/[^\d]/g, '');
};
var CNPJ = function () {
  function CNPJ() {
    _classCallCheck(this, CNPJ);
  }
  _createClass(CNPJ, null, [{
    key: 'validate',
    /**
     * Validates a CNPJ
     * @param {String|Number} cnpj The CNPJ value to be validated
     * @return {Boolean}
     */
    value: function validate(cnpj) {
      var cleaned = clean(cnpj);
      if (
      // Must be defined
      !cleaned ||
      // Must have 14 characters
      cleaned.length !== 14 ||
      // Must not be sequential characters (e.g.: 11111111111111, etc)
      /^(\d)\1+$/.test(cleaned)) {
        return false;
      }
      var registration = cleaned.substr(0, 12);
      registration += digit(registration);
      registration += digit(registration);
      return registration.substr(-2) === cleaned.substr(-2);
    }

    /**
     * Formats a CNPJ value
     * @param {String|Number} cnpj The CNPJ to be formatted
     * @return {String} The formatted CNPJ
     */
  }, {
    key: 'format',
    value: function format(cnpj) {
      return clean(cnpj).replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
    }

    /**
     * Generates a valid CNPJ
     * @return {String} The generated CNPJ
     */
  }, {
    key: 'generate',
    value: function generate() {
      var cnpj = '';
      var i = 12;
      while (i--) {
        cnpj += Math.floor(Math.random() * 9);
      }
      cnpj += digit(cnpj);
      cnpj += digit(cnpj);
      return CNPJ.format(cnpj);
    }
  }]);
  return CNPJ;
}();
exports.default = CNPJ;